<template>
    <div class="period-filter">
        <div class="period-filter__row">
            <div class="period-filter__group">
                <span class="period-filter__label">Сезон</span>
                <div class="period-chips">
                    <button
                        v-for="season in seasons"
                        :key="season.id"
                        type="button"
                        class="period-chip"
                        :class="{ 'period-chip--active': seasonId === season.id }"
                        @click="selectSeason(season.id)"
                    >
                        {{ season.name }}
                    </button>
                </div>
            </div>
            <div class="period-filter__group">
                <span class="period-filter__label">Вид игры</span>
                <div class="period-chips">
                    <button
                        v-for="comp in competitionTypes"
                        :key="comp.value"
                        type="button"
                        class="period-chip"
                        :class="{ 'period-chip--active': localCompetitions.includes(comp.value) }"
                        @click="toggleCompetition(comp.value)"
                    >
                        {{ comp.label }}
                    </button>
                </div>
            </div>
        </div>
        <div class="period-filter__footer">
            <span class="period-summary">{{ summaryText }}</span>
            <button type="button" class="btn-analytics" @click="$emit('open-analytics')">
                Аналитика
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
    seasons: { type: Array, default: () => [] },
    seasonId: { type: Number, default: null },
    competitionTypesSelected: { type: Array, default: () => ['championship', 'cup', 'supercup'] },
    matchesPlayed: { type: Number, default: 0 },
    setsPlayed: { type: Number, default: 0 },
});

const emit = defineEmits(['update:seasonId', 'update:competitionTypes', 'period-change', 'open-analytics']);

const competitionTypes = [
    { value: 'championship', label: 'Чемпионат' },
    { value: 'cup', label: 'Кубок' },
    { value: 'supercup', label: 'Суперкубок' },
];

const localCompetitions = ref([...props.competitionTypesSelected]);

watch(
    () => props.competitionTypesSelected,
    (v) => {
        localCompetitions.value = [...v];
    }
);

const summaryText = computed(() => {
    const m = props.matchesPlayed || 0;
    const s = props.setsPlayed || 0;
    const matchWord = m === 1 ? 'матч' : m >= 2 && m <= 4 ? 'матча' : 'матчей';
    const setWord = s === 1 ? 'партия' : s >= 2 && s <= 4 ? 'партии' : 'партий';
    return `${m} ${matchWord} · ${s} ${setWord}`;
});

const selectSeason = (id) => {
    emit('update:seasonId', id);
    emitPeriodChange();
};

const toggleCompetition = (value) => {
    const idx = localCompetitions.value.indexOf(value);
    if (idx >= 0) {
        if (localCompetitions.value.length > 1) {
            localCompetitions.value.splice(idx, 1);
        }
    } else {
        localCompetitions.value.push(value);
    }
    emit('update:competitionTypes', [...localCompetitions.value]);
    emitPeriodChange();
};

const emitPeriodChange = () => {
    emit('period-change', {
        seasonId: props.seasonId,
        competitionTypes: [...localCompetitions.value],
    });
};
</script>
